import React, { useContext, useEffect, useRef, useState } from "react";
import UniversalList from "../UniversalList/UniversalList";
import { dataType } from "../../components/UniversalList/UniversalList";
import { ICreateAlert } from "./type";
import { APIContext } from "../../store/APIStore";
import { StoreContext } from "../../store/Store";
import NotificationMessage from "../NotificationMessage/NotificationMessage";
import { notificationType } from "../UIComponents/Alert/FdAlert";
import { useParams } from "react-router-dom";

export interface IProps {
  onItemCheck?: Function;
  list: Array<ICreateAlert>;
  fetchAlertData: Function;
  setUpdate: Function;
  onCheckOut?: Function;
  bulkActions?: any;
  customActions?: any;
  hasCheckBox?: boolean;
}

export default function AlertList({ list, fetchAlertData, setUpdate }: IProps) {
  const api = useContext(APIContext);
  const [state, dispatch] = useContext(StoreContext);
  const { eventId } = useParams() as any;
  const { selectedAlert } = state;
  const [selectedIndex, setSelectedIndex] = useState(selectedAlert?.id);
  const notificationRef = useRef<any>();

  const onEdit = async (id?: number) => {
    setUpdate();
    setSelectedIndex(id);
    const editArr = list.filter((item) => item?.id === id);
    const editObj = editArr.reduce((cb, init) => init);
    dispatch({ type: "SET_SELECTED_ALERT", payload: editObj });
  };
  const onDelete = async (id: number) => {
    try {
      await api.alertService.deleteAlert(id, eventId);
      fetchAlertData(eventId);
      notificationRef.current?.show(
        "Alert Deleted successfully",
        notificationType.Success
      );
    } catch (error) {}
  };

  useEffect(() => {
    setSelectedIndex(selectedAlert?.id);
  }, [selectedAlert]);

  return (
    <UniversalList
      list={list}
      setUpdate={setUpdate}
      onEdit={onEdit}
      onDelete={onDelete}
      onCheckOut={() => {}}
      type={dataType.ALERT}
      selectedIndex={selectedIndex}
    />
  );
}
